export const SITE_URL = "https://biterecipes.co";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/bite-recipes/id6745537938";

// Every page that is pre-rendered at build time and listed in the sitemap.
// Routes not listed here (app hand-off pages like /open and /u/:id) are served
// by a no-index shell.
export const pages = [
  {
    path: "/",
    file: "index.html",
    title: "Bite: Save, Organize & Discover Recipes",
    description:
      "Save recipes from Instagram, TikTok, websites, photos and more. Organize recipes into collections, plan meals, create shopping lists and discover what to cook next with Bite.",
    shareDescription:
      "Save recipes from anywhere, organize them into collections and discover what to cook next with Bite.",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Bite",
      applicationCategory: "LifestyleApplication",
      operatingSystem: "iOS",
      description:
        "Bite is a recipe app for saving recipes from Instagram, TikTok, websites, photos and more. Organize recipes into collections, plan meals, create shopping lists and discover recipes from friends and creators.",
      url: `${SITE_URL}/`,
      downloadUrl: APP_STORE_URL,
    },
  },
  {
    path: "/privacy",
    file: "privacy.html",
    title: "Privacy Policy | Bite",
    description:
      "How Bite collects, uses, shares and protects your information, and the choices you have about your data.",
  },
  {
    path: "/terms",
    file: "terms.html",
    title: "Terms of Service | Bite",
    description:
      "The terms for using Bite, including community rules, your content, copyright, subscriptions and account termination.",
  },
  {
    path: "/delete-account",
    file: "delete-account.html",
    title: "Delete Your Bite Account",
    description:
      "How to request deletion of your Bite account and which data is removed or retained.",
  },
  {
    path: "/connect",
    file: "connect.html",
    title: "Use Bite with Claude & ChatGPT | Bite",
    description:
      "Connect Bite to Claude or ChatGPT to plan your week of meals, build a shopping list, save recipes from any link and find your saved recipes, right from chat.",
    shareDescription:
      "Plan the week, build the shopping list and save recipes from chat. Connect Bite to Claude or ChatGPT.",
  },
];

export const SHELL_TITLE = "Bite";

// Pre-rendered to build/404.html, which Firebase serves with a 404 status for
// any URL that isn't a page, an app route or a function (see firebase.json).
export const notFoundPage = {
  path: "/404",
  file: "404.html",
  title: "Page not found | Bite",
  description: "This page could not be found on Bite.",
  noindex: true,
};

export const canonicalUrl = page =>
  page.path === "/" ? `${SITE_URL}/` : `${SITE_URL}${page.path}`;

export const findPage = pathname => {
  const normalized =
    pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return pages.find(page => page.path === normalized);
};

const setHeadTag = (selector, create, attribute, value) => {
  let element = document.head.querySelector(selector);
  if (value == null) {
    element?.remove();
    return;
  }
  if (!element) {
    element = create();
    document.head.appendChild(element);
  }
  element.setAttribute(attribute, value);
};

const metaTag = (key, name) => () => {
  const element = document.createElement("meta");
  element.setAttribute(key, name);
  return element;
};

// Keeps the document head in sync after client-side navigation. The initial
// load already has these tags from pre-rendering.
export const applyPageMeta = (pathname, { notFound = false } = {}) => {
  const page = notFound ? notFoundPage : findPage(pathname);

  document.title = page ? page.title : SHELL_TITLE;
  setHeadTag(
    'meta[name="description"]',
    metaTag("name", "description"),
    "content",
    page?.description
  );
  setHeadTag(
    'link[rel="canonical"]',
    () => {
      const link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      return link;
    },
    "href",
    page && !page.noindex ? canonicalUrl(page) : null
  );
  setHeadTag(
    'meta[name="robots"]',
    metaTag("name", "robots"),
    "content",
    page && !page.noindex ? "index,follow" : "noindex"
  );
};
